import React from "react";
import { MDParty } from "../data/MDParty";

const NexratesCounterpartiesListData : React.FC<{
  data: MDParty[],
  onClickView: (code: string) => void
  onClickEdit: (code: string) => void
  onClickDisable: (code: string) => void
  onClickEnable: (code: string) => void
}> = ({data, onClickView, onClickEdit, onClickDisable, onClickEnable}) => {
    return <>
        {data.map((party) => (
            <tr key={party.partyCode + "-" + party.partyCodeSource}>
                <td>{party.partyCode}</td>
                <td>{party.description}</td>
                <td>{party.defaultSalesBook}</td>
                <td>{party.siteCode}</td>
                <td>
                <button className="btn btn-primary me-2" onClick={() => onClickView(party.partyCode)}>
                  <i className="bi bi-eye"></i> View
                </button>
                <button className="btn btn-warning me-2" onClick={() => onClickEdit(party.partyCode)}>
                  <i className="bi bi-pencil"></i> Edit
                </button>
                {party.isActive ? 
                  <button className="btn btn-danger" onClick={() => onClickDisable(party.partyCode)}>
                    <i className="bi bi-x-lg"></i> Deactivate
                  </button> : 
                  <button className="btn btn-success" onClick={() => onClickEnable(party.partyCode)}>
                    <i className="bi bi-check-lg"></i> Activate
                  </button>
                }
                </td>
            </tr>
        ))}  
    </>;
};

export default React.memo(NexratesCounterpartiesListData);